import IAddress from "./IAddress";

export default class Address implements IAddress {
    constructor(
        public streetAddress?: string,
        public streetNumber?: string,
        public city?: string,
        public zip?: string,
        public country?: string
    ) {}
}
